import { Link } from 'gatsby'
import React from 'react'
import { useImageLoaded } from '~/hooks/useImage'
import defaultProfileImage from '~/images/default-author-icon.png';

const BlogPostCard: React.FC<{ block: BlogPost, to: string }> = ({ block, to }) => {
  const [imageRef, loaded, onLoad] = useImageLoaded()

  return (
    <div className="col-12 col-md-6 col-xl-4">
      <Link to={to}>
        <div className={`post-card ${loaded ? "" : "post-card--loading"}`}>
          <div className="image-wr">
            <img
              ref={imageRef}
              className="image-wr__image"
              src={block.feature_image}
              alt={block.feature_image}
              onLoad={onLoad}
            />
          </div>
          <div className="content-wr content-wr--title">
            {block.primary_tag && (
              <h3 className="text-orange-gradient post-card__category">
                {block.primary_tag.name}
              </h3>
            )}
            <div className="post-card__title">{block.title}</div>
          </div>
          <div className="content-wr content-wr--author">
            {block.primary_author && <PostAuthor author={block.primary_author} />}
            {block.published_at && <PublishedAt dateTime={block.published_at} />}
          </div>
        </div>
      </Link>
    </div>
  )
}

export const PostAuthor: React.FC<{
  author: BlogPost['primary_author']
}> = ({ author }) => {
  if (!author) {
    return null;
  }

  return (
    <div className="post-author">
      <div className="post-author__icon">
        <img src={author.profile_image || defaultProfileImage} alt={author.name} />
      </div>
      <h3 className="post-author__name">{author.name}</h3>
    </div>
  )
}

export const PublishedAt: React.FC<{
  dateTime: BlogPost['published_at']
  showIcon?: boolean
}> = ({ dateTime, showIcon = false }) => {
  const publishedAt = new Date(dateTime);
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  } as any;
  const formatedDate = publishedAt.toLocaleDateString('en-US', options);
  
  return (
    <div className="post-published">
      {showIcon && (
        <div className="post-published__icon">
          <img
            src="https://bunnycdn.com/assets/v2/images/general/ic-wall-clock.svg"
            alt="Wall clock"
          />
        </div>
      )}
      <h3 className="post-published__date">{formatedDate}</h3>
    </div>
  )
}

export default BlogPostCard
